import { call, put, select } from 'redux-saga/effects';

import request from '../request';
import selectors from '../../../selectors';
import actions from '../../../actions';
import api from '../../../api';
import orm from '../../../orm';

const putPlansForPointSystem = function* putPlansForPointSystem(pointSystemId, items) {
  yield put(actions.fetchEmployeePlans.success(pointSystemId, items));
};

export function* fetchEmployeePlansInCurrentBoard(pointSystemIdParam = null) {
  let pointSystemId = pointSystemIdParam;

  if (!pointSystemId) {
    const pointSystem = yield select(selectors.selectPointSystemForSettingsModal);
    if (!pointSystem) {
      return;
    }
    pointSystemId = pointSystem.id;
  }

  yield put(actions.fetchEmployeePlans(pointSystemId));

  let items;
  try {
    ({ items } = yield call(request, api.getEmployeePlans, pointSystemId));
  } catch (error) {
    // Не затираем уже загруженные планы (например из boards/show)
    yield put(actions.fetchEmployeePlans.failure(pointSystemId, error));
    return;
  }

  if (!items || items.length === 0) {
    const session = orm.session(yield select((state) => state.orm));
    const existing = session.EmployeePlan.all()
      .toRefArray()
      .filter((plan) => String(plan.pointSystemId) === String(pointSystemId));
    if (existing.length > 0) {
      return;
    }
  }

  if (items && items.length > 0) {
    const storePointSystemId = items[0].pointSystemId || pointSystemId;
    yield call(putPlansForPointSystem, storePointSystemId, items);
    return;
  }

  yield call(putPlansForPointSystem, pointSystemId, items || []);
}

export function* createEmployeePlanInCurrentBoard(data = {}) {
  const pointSystem = yield select(selectors.selectPointSystemForSettingsModal);
  if (!pointSystem) {
    return;
  }

  yield put(actions.createEmployeePlan(pointSystem.id, data));

  let item;
  try {
    ({ item } = yield call(request, api.createEmployeePlan, pointSystem.id, data));
  } catch (error) {
    yield put(actions.createEmployeePlan.failure(pointSystem.id, error));
    return;
  }

  yield put(actions.createEmployeePlan.success(item));
  yield call(fetchEmployeePlansInCurrentBoard, pointSystem.id);
}

export function* updateEmployeePlan(id, data) {
  yield put(actions.updateEmployeePlan(id, data));

  let item;
  try {
    ({ item } = yield call(request, api.updateEmployeePlan, id, data));
  } catch (error) {
    yield put(actions.updateEmployeePlan.failure(id, error));
    return;
  }

  yield put(actions.updateEmployeePlan.success(item));
}

export function* deleteEmployeePlan(id) {
  yield put(actions.deleteEmployeePlan(id));

  let item;
  try {
    ({ item } = yield call(request, api.deleteEmployeePlan, id));
  } catch (error) {
    yield put(actions.deleteEmployeePlan.failure(id, error));
    return;
  }

  yield put(actions.deleteEmployeePlan.success(item));
  yield call(fetchEmployeePlansInCurrentBoard);
}

export default {
  fetchEmployeePlansInCurrentBoard,
  createEmployeePlanInCurrentBoard,
  updateEmployeePlan,
  deleteEmployeePlan,
};
